<template>
  <RadioGroupRoot v-model="localValue" :aria-label="ariaLabel" :name="name" class="radiobutton-group">
    <div v-for="option in options" :key="option.value" class="radio-row">
      <RadioGroupItem :id="`${name}-${option.value}`" :value="String(option.value)" />
      <label :for="`${name}-${option.value}`">
        {{ option.label }}
      </label>
    </div>
  </RadioGroupRoot>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { RadioGroupRoot, RadioGroupItem } from 'radix-vue';

export interface Option {
  value: string;
  label: string;
}

defineProps<{
  options: Option[];
  name: string;
  ariaLabel: string;
}>();

const localValue = defineModel<string | undefined>();
</script>
